module.exports = __webpack_public_path__ + "static/media/vf_mknit_core.a1c88f4f.svg";